import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useLang } from "../i18n/LanguageContext";

const serviceSlugs = ["daca", "aos", "remove-conditions", "u-visa", "citizenship", "advance-parole", "vawa", "translation", "other"];

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-espresso text-cream" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-4">
            <Logo withText dark size={48} />
            <p className="text-sm leading-relaxed text-cream/70">{t.footer.tagline}</p>
            <p className="text-xs text-cream/50 italic">{t.footer.socialSoon}</p>
          </div>

          <div>
            <h3 className="font-serif text-lg mb-4">{t.footer.quickLinks}</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link className="text-cream/70 hover:text-sand transition-colors" to="/" data-testid="footer-link-home">{t.nav.home}</Link></li>
              <li><Link className="text-cream/70 hover:text-sand transition-colors" to="/pricing" data-testid="footer-link-pricing">{t.nav.pricing}</Link></li>
              <li><Link className="text-cream/70 hover:text-sand transition-colors" to="/how-it-works" data-testid="footer-link-how-it-works">{t.nav.howItWorks}</Link></li>
              <li><Link className="text-cream/70 hover:text-sand transition-colors" to="/about" data-testid="footer-link-about">{t.nav.about}</Link></li>
              <li><Link className="text-cream/70 hover:text-sand transition-colors" to="/faq" data-testid="footer-link-faq">{t.nav.faq}</Link></li>
              <li><Link className="text-cream/70 hover:text-sand transition-colors" to="/contact" data-testid="footer-link-contact">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-serif text-lg mb-4">{t.footer.servicesTitle}</h3>
            <ul className="space-y-2.5 text-sm">
              {serviceSlugs.map((slug) => (
                <li key={slug}>
                  <Link
                    className="text-cream/70 hover:text-sand transition-colors"
                    to={`/services/${slug}`}
                    data-testid={`footer-service-link-${slug}`}
                  >
                    {t.services[slug].name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-serif text-lg mb-4">{t.footer.contactTitle}</h3>
            <ul className="space-y-2.5 text-sm text-cream/70" data-testid="footer-contact-info">
              <li>{t.contact.info.email}</li>
              <li>{t.contact.info.phone}</li>
              <li>{t.contact.info.hours}</li>
              <li>{t.contact.info.area}</li>
              <li className="text-xs text-cream/50">{t.contact.responseNote}</li>
            </ul>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link className="text-cream/70 hover:text-sand transition-colors" to="/privacy" data-testid="footer-link-privacy">{t.footer.privacy}</Link></li>
              <li><Link className="text-cream/70 hover:text-sand transition-colors" to="/terms" data-testid="footer-link-terms">{t.footer.terms}</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 rounded-2xl border border-sand/25 bg-white/5 p-6 sm:p-8" data-testid="legal-disclaimer">
          <div className="grid gap-8 lg:grid-cols-2">
            <div>
              <h3 className="font-serif text-base font-semibold uppercase tracking-wider text-sand mb-3">
                {t.footer.legalTitle}
              </h3>
              <div className="space-y-3 text-[0.8rem] leading-relaxed text-cream/75">
                {t.footer.legalText.map((p, i) => (
                  <p key={i} className={i === 0 ? "font-bold text-cream" : ""}>{p}</p>
                ))}
              </div>
            </div>
            <div>
              <h3 className="font-serif text-base font-semibold uppercase tracking-wider text-sand mb-3">
                {t.footer.avisoTitle}
              </h3>
              <div className="space-y-3 text-[0.8rem] leading-relaxed text-cream/75">
                {t.footer.avisoText.map((p, i) => (
                  <p key={i} className={i === 0 ? "font-bold text-cream" : ""}>{p}</p>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center gap-2 border-t border-sand/20 pt-6 text-center">
          <p className="font-mono text-xs text-sand" data-testid="bond-disclosure">
            {t.common.bond}
          </p>
          <p className="text-xs text-cream/50">{t.footer.copyright.replace("{year}", year)}</p>
        </div>
      </div>
    </footer>
  );
}
